import React from "react";

export const AudienceMarketReadyLoader = () => {

  return (
    <div className="tw-min-h-[calc(100vh-64px)] tw-flex tw-flex-col tw-bg-white tw-w-full tw-p-8 tw-overflow-hidden font-inter">
      <style>{`
        @keyframes shimmerWave {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .animate-shimmer {
          background: linear-gradient(90deg, #F1F5F9 25%, #E2E8F0 50%, #F1F5F9 75%);
          background-size: 200% 100%;
          animation: shimmerWave 1.8s infinite linear;
        }
        @keyframes sonarPulse {
          0% { transform: scale(0.95); opacity: 0.9; }
          50% { transform: scale(1.3); opacity: 0.4; }
          100% { transform: scale(0.95); opacity: 0.9; }
        }
        .animate-sonar {
          animation: sonarPulse 2s infinite ease-in-out;
        }
      `}</style>



      {/* Header section Skeleton (Matches screenshot layout) */}
      <div className="tw-flex tw-flex-col tw-gap-4 tw-mb-6 tw-flex-shrink-0">
        
        {/* Breadcrumb Skeleton */}
        <div className="tw-flex tw-items-center tw-gap-2">
          <div className="tw-w-16 tw-h-3.5 tw-rounded-md animate-shimmer" />
          <span className="tw-text-slate-300">/</span>
          <div className="tw-w-28 tw-h-3.5 tw-rounded-md animate-shimmer" />
        </div>

        {/* Title + Badges + Metrics Split */}
        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-start tw-gap-6">
          <div className="tw-flex tw-items-start tw-gap-4">
            
            {/* Back Button Skeleton */}
            <div className="tw-h-10 tw-w-10 tw-rounded-xl animate-shimmer tw-flex-shrink-0" />

            <div className="tw-flex-1">
              {/* Title & Badges Row */}
              <div className="tw-flex tw-items-center tw-gap-3 tw-flex-wrap">
                <div className="tw-w-44 tw-h-7 tw-rounded-lg animate-shimmer" />
                <div className="tw-w-16 tw-h-5 tw-rounded-full animate-shimmer" />
                <div className="tw-w-14 tw-h-5 tw-rounded-full animate-shimmer" />
              </div>

              {/* Tags Row */}
              <div className="tw-flex tw-items-center tw-gap-2 tw-mt-3">
                <div className="tw-w-20 tw-h-6 tw-rounded-full animate-shimmer" />
                <div className="tw-w-16 tw-h-6 tw-rounded-full animate-shimmer" />
              </div>

              {/* Description Skeleton Box */}
              <div className="tw-mt-3 tw-w-full lg:tw-w-[420px] tw-h-14 tw-rounded-xl animate-shimmer" />
            </div>
          </div>

          {/* Right Metrics Cards Skeletons */}
          <div className="tw-flex tw-gap-4 tw-flex-shrink-0 tw-w-full lg:tw-w-auto">
            
            {/* Total Contacts Card */}
            <div className="tw-flex-1 lg:tw-flex-initial tw-flex tw-items-center tw-gap-4 tw-bg-white tw-px-5 tw-py-4 tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm">
              <div className="tw-h-11 tw-w-11 tw-rounded-xl animate-shimmer tw-flex-shrink-0" />
              <div className="tw-flex tw-flex-col tw-gap-2">
                <div className="tw-w-24 tw-h-3 tw-rounded animate-shimmer" />
                <div className="tw-w-16 tw-h-6 tw-rounded-md animate-shimmer" />
              </div>
            </div>

            {/* WhatsApp Ready Card */}
            <div className="tw-flex-1 lg:tw-flex-initial tw-flex tw-items-center tw-gap-4 tw-bg-white tw-px-5 tw-py-4 tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm">
              <div className="tw-h-11 tw-w-11 tw-rounded-xl animate-shimmer tw-flex-shrink-0" />
              <div className="tw-flex tw-flex-col tw-gap-2">
                <div className="tw-w-28 tw-h-3 tw-rounded animate-shimmer" />
                <div className="tw-w-16 tw-h-6 tw-rounded-md animate-shimmer" />
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Tabs Container Skeleton */}
      <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-2xl tw-shadow-sm tw-flex tw-flex-col tw-flex-grow tw-overflow-hidden">
        
        {/* Tab Navigation Row Skeleton */}
        <div className="tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-slate-100 tw-px-6 tw-py-4 tw-bg-white">
          <div className="tw-w-24 tw-h-9 tw-rounded-xl animate-shimmer" />
          <div className="tw-w-28 tw-h-9 tw-rounded-xl animate-shimmer" />
          <div className="tw-w-24 tw-h-9 tw-rounded-xl animate-shimmer" />
        </div>

        {/* Table Content Skeleton Area */}
        <div className="tw-p-6">
          
          {/* Action Row: Title & Buttons */}
          <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
            <div className="tw-w-40 tw-h-6 tw-rounded-lg animate-shimmer" />
            <div className="tw-flex tw-items-center tw-gap-3">
              <div className="tw-w-24 tw-h-9 tw-rounded-xl animate-shimmer" />
              <div className="tw-w-32 tw-h-9 tw-rounded-xl animate-shimmer" />
            </div>
          </div>

          {/* Table Header Row Skeleton */}
          <div className="tw-grid tw-grid-cols-5 tw-gap-4 tw-pb-3 tw-border-b tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-slate-100 tw-mb-4">
            <div className="tw-w-16 tw-h-3.5 tw-rounded animate-shimmer" />
            <div className="tw-w-28 tw-h-3.5 tw-rounded animate-shimmer" />
            <div className="tw-w-20 tw-h-3.5 tw-rounded animate-shimmer" />
            <div className="tw-w-20 tw-h-3.5 tw-rounded animate-shimmer" />
            <div className="tw-w-28 tw-h-3.5 tw-rounded animate-shimmer" />
          </div>

          {/* 6 Table Row Skeletons */}
          <div className="tw-flex tw-flex-col tw-gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div
                key={i}
                className="tw-grid tw-grid-cols-5 tw-gap-4 tw-items-center tw-py-2.5 tw-border-b tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-slate-50"
              >
                <div className="tw-w-24 tw-h-4 tw-rounded animate-shimmer" />
                <div className="tw-w-28 tw-h-4 tw-rounded animate-shimmer" />
                <div className="tw-w-36 tw-h-4 tw-rounded animate-shimmer" />
                <div className="tw-w-20 tw-h-4 tw-rounded animate-shimmer" />
                <div className="tw-w-12 tw-h-6 tw-rounded-full animate-shimmer" />
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
};

export default AudienceMarketReadyLoader;
